import { Box, Skeleton, Text, Tooltip } from '@mantine/core';
import type { ReactNode } from 'react';

interface DetailProps {
	label: string;
	stringValue?: string;
	children?: ReactNode;
	isLoading?: boolean;
	isUndefined?: boolean;
}

export function Detail({
	label,
	stringValue,
	isLoading = false,
	isUndefined,
	children,
}: DetailProps) {
	const detailsStateConditional = () => {
		// No value
		if (isUndefined || (!children && (stringValue === '' || !stringValue)))
			return (
				<i>
					<Text c={'grey'}>N/A</Text>
				</i>
			);

		// If value is a string
		if (stringValue) {
			return (
				<Tooltip label={stringValue} position="bottom-start" offset={3}>
					<Text truncate>{stringValue}</Text>
				</Tooltip>
			);
		}

		// If value is an element
		if (children) {
			return <Text>{children}</Text>;
		}

		return <Text c={'red'}>Something went wrong!!!</Text>;
	};

	return (
		<Box pb={5}>
			<Text c={'black'} pb={5} fw={500}>
				<b>{`${label}: `}</b>
			</Text>
			<Skeleton visible={isLoading}>{detailsStateConditional()}</Skeleton>
		</Box>
	);
}
